import s from "../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import c from "../../../@babel/runtime/helpers/esm/extends.js";
import i, { forwardRef as a } from "react";
import o from "./Lock.js";
import m from "./Trap.js";
var r = /* @__PURE__ */ a(function(t, p) {
  return /* @__PURE__ */ i.createElement(o, c({
    sideCar: m,
    ref: p
  }, t));
}), e = o.propTypes || {};
e.sideCar;
var f = s(e, ["sideCar"]);
r.propTypes = process.env.NODE_ENV !== "production" ? f : {};
const L = r;
export {
  L as default
};
